import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ProductCardProvider } from '../../contexts/ProductCardContext';
import ProductCard from '../ProductCard/ProductCard';
import './index.css';

const ProductsCarousel = ({
  props,
  products,
  breakpoints = {
    0: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    400: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    600: {
      slidesPerView: 3,
      slidesPerGroup: 3
    },
    800: {
      slidesPerView: 4,
      slidesPerGroup: 4
    }
  }
}) => {
  const [cookie] = useCookies(['userToken']);
  const { role } = useSelector((state) => state.user);

  return (
    <ProductCardProvider>
      <Swiper
        {...props}
        spaceBetween={32}
        breakpoints={breakpoints}
        navigation
        modules={[Navigation]}
        className='products-carousel'
      >
        {products.map((product, index) => (
          <SwiperSlide key={`products-carousel-${product.reference}-${index}`}>
            <ProductCard
              product={product}
              userIsLogged={!!cookie.userToken && role !== 'limitedcustomer'}
              showRevPrice={true}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </ProductCardProvider>
  );
};

export default ProductsCarousel;
